import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import React from 'react'

interface CollapseProps {
  /**
   * The direction of the flex layout when the collapse is open
   * @default 'col'
   */
  dir?: 'col' | 'row'
  /**
   * The id attribute of the collapse container element
   */
  id?: string
  /**
   * Whether the collapse is currently open/visible
   * @default false
   */
  open?: boolean
}

function Collapse({
  children,
  dir = 'col',
  id,
  open = false,
}: PropsWithChildren<CollapseProps>): JSX.Element | null {
  return (
    <div
      className={clsx(
        open
          ? ['flex overflow-hidden', dir === 'col' ? 'flex-col' : 'flex-row']
          : 'hidden',
      )}
      id={id}
    >
      {children}
    </div>
  )
}

export default Collapse
